import { render, staticRenderFns } from "./ExamplePricingRules.vue?vue&type=template&id=1e5fe20c"
import script from "./ExamplePricingRules.vue?vue&type=script&lang=js"
export * from "./ExamplePricingRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports